import { Button, ButtonRow, Card, Text } from '@ksyos/design-system';
import { styled } from 'styled-components';
import type { IAltoStepProps } from '../../NewAltoDermaOthProcedure';
import type { IRegularStepProps } from '../../NewDermaOthProcedure';
import { CustomContainer } from '../../../../elements/molecules/customContainer/CustomContainer';
import { Stack } from '../../../../elements/molecules/stack/Stack';
import { PageIntro } from '../../../../elements/organisms/pageIntro/PageIntro';

export function Step1(props: (IRegularStepProps | IAltoStepProps) & { altoFlow?: boolean }) {
    return (
        <>
            <PageIntro
                subtitle={`Duidelijke foto's zijn belangrijk voor de huisarts om ${
                    props.altoFlow ? 'goed te kunnen helpen' : 'je goed te kunnen helpen.'
                }`}
                title="Hoe maak ik een duidelijke foto?"
            />
            <CustomContainer>
                <Stack>
                    <Card>
                        <GridContainer>
                            <GridItem>
                                <StyledImg
                                    alt="Contrast"
                                    src="/assets/images/derma-oth/contrast.svg"
                                ></StyledImg>
                                <Text size={['sm', null, 'md']}>Goed contrast</Text>
                            </GridItem>
                            <GridItem>
                                <StyledImg
                                    alt="Belichting"
                                    src="/assets/images/derma-oth/belichting.svg"
                                ></StyledImg>
                                <Text size={['sm', null, 'md']}>Goede belichting</Text>
                            </GridItem>
                            <GridItem>
                                <StyledImg
                                    alt="Scherpte"
                                    src="/assets/images/derma-oth/scherpte.svg"
                                ></StyledImg>
                                <Text size={['sm', null, 'md']}>Scherpe foto</Text>
                            </GridItem>
                            <GridItem>
                                <StyledImg
                                    alt="Vraag"
                                    src="/assets/images/derma-oth/vraag.svg"
                                ></StyledImg>
                                <Text size={['sm', null, 'md']}>Vraag om hulp</Text>
                            </GridItem>
                        </GridContainer>
                    </Card>
                </Stack>
                <ButtonRow justify="right">
                    <Button
                        color="secondary"
                        onClick={props.validateAndGoToNextStep}
                        variant="solid"
                        width="full-below-small"
                    >
                        Verder naar de overzichtsfoto
                    </Button>
                </ButtonRow>
            </CustomContainer>
        </>
    );
}

const GridContainer = styled.div`
    min-height: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
`;

const GridItem = styled.div`
    display: flex;
    width: 50%;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 16px;

    @media screen and (min-width: 480px) {
        padding: 24px;
    }

    @media screen and (min-width: 768px) {
        padding: 40px;
    }

    &:first-child {
        border-right: 1px solid #ecece6;
        border-bottom: 1px solid #ecece6;
    }
    &:nth-child(2) {
        border-left: 1px solid #ecece6;
        border-bottom: 1px solid #ecece6;
    }
    &:nth-child(3) {
        border-top: 1px solid #ecece6;
        border-right: 1px solid #ecece6;
    }
    &:last-child {
        border-top: 1px solid #ecece6;
        border-left: 1px solid #ecece6;
    }
`;

const StyledImg = styled.img`
    width: 84px;
    margin-bottom: 16px;

    @media screen and (min-width: 768px) {
        width: 124px;
        margin-bottom: 24px;
    }

    @media screen and (min-width: 1024px) {
        width: 164px;
    }
`;
